/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable import/order */
// -----------------------------------------------------------------------------
// <copyright file="select.component.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  NgZone,
  OnChanges,
  OnDestroy,
  ViewEncapsulation,
  input,
  output,
  viewChild,
} from '@angular/core';

import { UntypedFormControl } from '@angular/forms';
import { SelectItem } from '../../interfaces/Iselect';
@Component({
  selector: 'fs-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectComponent implements OnChanges, OnDestroy {
  txt = viewChild<ElementRef>('txt');
  list = input<SelectItem[]>([]);
  placeholder = input<string>('Select');
  default = input<SelectItem | null>(null);
  diableLabel = input<boolean>(false);
  errorMessage = input<string>('');
  isNullable = input<boolean>(false);
  sortNumeric = input<boolean>(false);
  classes = input<string>('');
  noSort = input<boolean>(false);
  isProposal = input<boolean>(false);
  disabled = input<boolean>(false);
  editable = input<boolean>(false);
  readOnly = input<boolean>(false);
  filterList = input<boolean>(false);
  bottomPadding = input<any>(null);
  dynamicWidth = input<boolean>(false);
  fixedWidth = input<number>(0); // To give the static width to dropdown
  offsetY = input<number>(0); // Adjust the space between container and dropdown
  appendButton = input<boolean>(false);
  buttonText = input<any>(null);
  isPostBid = input<boolean>(false);
  isPostBidCustomer = input<boolean>(false);
  isMfrRep = input<boolean>(false);
  id = input<string>('ei-select-input');
  onChange = output<SelectItem>();
  onButtonClicked = output<boolean>();
  public noneItem: SelectItem = { text: 'Select One', id: null };
  public control: UntypedFormControl = new UntypedFormControl();
  public selectedItemId = null;
  public index = -1;
  public search = false;
  public showdd = false;
  public ddStyle: any = {};
  public filter: string = '';
  public pList: SelectItem[] = [];
  constructor(private zone: NgZone) {}
  public ngOnDestroy(): void {
    this.remove();
  }

  public ngOnChanges() {
    const listValue = this.list();
    if (listValue && Array.isArray(listValue)) {
      this.pList = [...listValue];
    } else {
      // console.error("Error: `this.list` is not iterable.");
    }
    if (!this.noSort()) {
      this.pList = this.pList.sort((a, b) => {
        if (this.sortNumeric()) {
          return +a.text - +b.text;
        } else {
          return a.text.localeCompare(b.text);
        }
      });
    }

    if (this.isNullable()) {
      this.pList = [{ text: 'Select One', id: null } as SelectItem, ...this.pList];
      // editable is readonly from input(), cannot be modified
      const defaultVal = this.default();
      if (!defaultVal || !defaultVal.text) {
        // Cannot set default as it's readonly
      }
    }

    const defaultVal = this.default();
    if (defaultVal && defaultVal.text) {
      this.control.setValue(defaultVal.text);
      this.selectedItemId = defaultVal.id;
    } else {
      this.selectedItemId = null;
      this.control.reset();
    }
  }

  public initEvent() {
    this.zone.runOutsideAngular(() => {
      window.addEventListener('keydown', this.disableScroll, false);
      window.addEventListener('scroll', this.scrollRemove, true);
      window.addEventListener('resize', this.remove, true);
      window.addEventListener('click', this.outClick, true);
    });
  }

  public scrollRemove = (event: any) => {
    const txtElement = this.txt();
    if (txtElement) {
      txtElement.nativeElement.blur();
    }
    this.remove(event);
  };

  public unbind() {
    window.removeEventListener('keydown', this.disableScroll, false);
    window.removeEventListener('scroll', this.scrollRemove, true);
    window.removeEventListener('resize', this.remove, true);
    window.removeEventListener('click', this.outClick, true);
    this.remove();
  }

  public disableScroll(e: any) {
    switch (e.keyCode) {
      case 38:
      case 40: // Arrow keys
      case 666:
        e.preventDefault();
        break; // Space
      default:
        break; // do not block other keys
    }
  }

  public initDD(event: any): void {
    this.remove();
    if (this.readOnly()) {
      return;
    }
    const ul = document.createElement('ul');
    ul.id = 'eiselectdd';
    if (this.classes()) {
      ul.className = this.classes();
    }
    const pos = event.target.getBoundingClientRect();
    if (this.isPostBid()) {
      if (pos.top + pos.height + 210 > window.innerHeight) {
        ul.style.bottom = window.innerHeight - pos.top + 'px';
        ul.style.maxHeight = window.innerHeight - (window.innerHeight - pos.top) + 'px';
      } else {
        ul.style.top = pos.top + pos.height + 'px';
        ul.style.maxHeight =
          window.innerHeight + 30 - (pos.top + pos.height + (this.bottomPadding() || 0)) + 'px';
      }
    } else {
      if (pos.top + pos.height + 270 > window.innerHeight) {
        const ht = window.innerHeight - (window.innerHeight - pos.top + 70);
        ul.style.bottom = window.innerHeight - pos.top + this.offsetY() + 'px';
        ul.style.maxHeight = (ht > 600 ? 600 : ht) + 'px';
      } else {
        ul.style.top = pos.top + pos.height + this.offsetY() + 'px';
        const ht = window.innerHeight - (pos.top + pos.height + (this.bottomPadding() || 0) + 70);
        ul.style.maxHeight = (ht > 600 ? 600 : ht) + 'px';
      }
    }
    if (this.isProposal()) {
      ul.style.width = 250 + 'px';
    } else if (this.dynamicWidth()) {
      ul.style.width = 'max-content';
    } else if (this.fixedWidth()) {
      ul.style.width = this.fixedWidth() + 'px';
    } else {
      ul.style.width = pos.width + 'px';
    }
    ul.style.left = pos.left + 'px';
    if (this.isPostBidCustomer()) {
      window.addEventListener('click', this.outClick, true);
    }
    ul.addEventListener('click', this.itemClickHandler, false);
    ul.addEventListener('scroll', (event) => {
      event.stopPropagation();
    });
    const isEdit = this.editable() ? !this.checkExisitng() : false;
    if (this.control.value && isEdit && !this.filterList()) {
      this.pList.unshift({ text: this.control.value, id: this.control.value } as SelectItem);
    }
    for (let i = 0; i < this.pList.length; i++) {
      const record = this.pList[i];
      const li = document.createElement('li');
      if (this.isMfrRep()) {
        li.innerText =
          record.text +
          (record.id
            ? ' (' +
              (record.text !== 'Other' && record.text !== 'None'
                ? record.id.toUpperCase()
                : record.id) +
              ')'
            : '');
      } else {
        li.innerText = record.text;
      }
      if (i === 0 && isEdit && !this.filterList()) {
        li.setAttribute('value', '-99');
      } else {
        li.setAttribute('value', '' + i);
      }
      li.addEventListener('mouseover', () => {
        li.className = 'active';
      });
      li.addEventListener('mouseout', () => {
        if (
          (!this.isMfrRep() && this.selectedItemId === record.id) ||
          (this.isMfrRep() && this.selectedItemId === record.text)
        ) {
          li.className = 'active-text';
        } else {
          li.className = '';
        }
      });
      if (
        (!this.isMfrRep() && this.selectedItemId === record.id) ||
        (this.isMfrRep() && this.selectedItemId === record.text)
      ) {
        li.className = 'active-text';
      }
      if (record.textColor) {
        li.style.color = record.textColor;
        if (this.selectedItemId === record.id) {
          li.className = 'active-color';
        }
      }
      if (record.showBorder) {
        li.style.borderBottom = '1px solid #ccc';
      }

      ul.appendChild(li);
    }
    if (this.appendButton()) {
      // adding new button in the list to add new option
      const li = document.createElement('li');
      li.innerText = this.buttonText();
      li.setAttribute('value', 'new-option');
      li.className = 'new-option';
      ul.appendChild(li);
    }
    document.body.appendChild(ul);
  }

  public remove = (event?: any) => {
    if (event && event.target === window) {
      const eul = document.getElementById('eiselectdd');
      if (eul) {
        eul.remove();
        this.unbind();
      }
      return;
    }
    if (
      event &&
      event.target !== document &&
      (event.target.id === 'eiselectdd' || event.target.parentNode.className === 'eselect')
    ) {
      return;
    }
    const eul = document.getElementById('eiselectdd');
    if (eul) {
      eul.remove();
      this.unbind();
    }
  };

  public outClick = (event: any) => {
    this.remove(event);
  };

  public itemClickHandler = (event: any) => {
    event.stopPropagation();
    this.setValue(event.target);
  };

  public setValue(el: any) {
    if (!el) {
      return;
    }
    // handle event custom action button in the list
    if (this.appendButton() && el.getAttribute('value') == 'new-option') {
      this.onButtonClicked.emit(true);
      return;
    }
    this.index = +el.getAttribute('value');
    this.remove();
    if (this.index === -99) {
      this.index = 0;
      this.onChange.emit({ text: this.control.value, id: this.control.value } as SelectItem);
    } else {
      this.control.setValue(this.pList[this.index].text);
      this.selectedItemId = this.pList[this.index].id;
      this.onChange.emit(this.pList[this.index]);
    }

    const val = this.control.value;
    this.control.reset();
    this.control.setValue(val);
  }

  public onFocus(event: any) {
    this.unbind();
    if (this.disabled()) {
      return;
    }
    event.stopPropagation();
    setTimeout(() => {
      this.initEvent();
      this.initDD(event);
      if (this.isMfrRep()) {
        event.srcElement.select();
      }
    });
  }

  public onBlur() {
    if (this.disabled() || this.filterList()) {
      return;
    }
    if (this.control.dirty) {
      this.onChange.emit({
        text: this.control.value,
        id: this.control.value ? this.control.value : null,
      } as SelectItem);
      const val = this.control.value;
      this.control.reset();
      this.control.setValue(val);
    }
  }

  public onKeyup(event: any): void {
    if (event.which === 13) {
      const eul = document.getElementById('eiselectdd');
      if (eul) {
        const li = eul.querySelector('.active');
        if (li) {
          this.setValue(li);
          event.target.blur();
        }
      }
      return;
    }

    if (event.which === 38) {
      const eul = document.getElementById('eiselectdd');
      if (eul) {
        const li = eul.querySelector('.active');
        if (li) {
          if (li.previousElementSibling) {
            li.className = '';
            li.previousElementSibling.className = 'active';
          }
        } else {
          if (eul.firstElementChild) {
            eul.firstElementChild.className = 'active';
          }
        }
      }

      return;
    }

    if (event.which === 40) {
      const eul = document.getElementById('eiselectdd');
      if (eul) {
        const li = eul.querySelector('.active');
        if (li) {
          if (li.nextElementSibling) {
            li.className = '';
            li.nextElementSibling.className = 'active';
          }
        } else {
          if (eul.firstElementChild) {
            eul.firstElementChild.className = 'active';
          }
        }
      }

      return;
    }
    if (event.which === 9 && this.isMfrRep()) {
      this.onFocus(event);
      return;
    }
    if (this.filterList()) {
      let updatedList = [];
      if (this.isMfrRep()) {
        updatedList = this.list().filter(
          (element) =>
            element.text.toLowerCase().indexOf(this.control.value.toLowerCase()) > -1 ||
            element.id?.toLowerCase().indexOf(this.control.value.toLowerCase()) > -1,
        );
      } else {
        updatedList = this.list().filter(
          (element) => element.text.toLowerCase().indexOf(this.control.value.toLowerCase()) > -1,
        );
      }
      if (!this.noSort) {
        updatedList = updatedList.sort((a, b) => {
          if (this.sortNumeric()) {
            return +a.text - +b.text;
          } else {
            return a.text.localeCompare(b.text);
          }
        });
      }
      if (this.isNullable() && !this.control.value) {
        this.pList = [{ text: 'Select One', id: null } as SelectItem, ...updatedList];
      } else {
        if (this.isMfrRep() && this.control.value) {
          updatedList = updatedList.filter(
            (element) =>
              element.text !== 'Select One' && element.text !== 'Other' && element.text !== 'None',
          );
        }
        this.pList = [...updatedList];
      }
      if (this.editable()) {
        if (this.isMfrRep()) {
          this.initDD(event);
        } else {
          this.onFocus(event);
        }
      }
      return;
    }

    this.enableEditable();
  }

  public enableEditable() {
    if (!this.editable) {
      return;
    }
    if (this.control.value) {
      if (this.checkExisitng()) {
        const eul = document.getElementById('eiselectdd');
        if (eul) {
          const lli = eul.querySelector('li[value="-99"]') as any;
          if (lli) {
            lli.remove();
          }
        }
      } else {
        const eul = document.getElementById('eiselectdd');
        if (eul) {
          const lli = eul.querySelector('li[value="-99"]') as any;
          const active = eul.querySelector('li.active') as any;
          if (active) {
            active.className = '';
          }
          if (lli) {
            lli.innerText = this.control.value;
            lli.className = 'active';
          } else {
            const li = document.createElement('li');
            li.innerText = this.control.value;
            li.setAttribute('value', '-99');
            li.className = 'active';
            eul.insertBefore(li, eul.firstElementChild);
          }
        }
      }
    } else {
      const eul = document.getElementById('eiselectdd');
      if (eul) {
        const lli = eul.querySelector('li[value="-99"]') as any;
        if (lli) {
          lli.remove();
        }
      }
    }
  }

  public checkExisitng() {
    if (!this.control.value) {
      return true;
    }
    for (let i = 0; i < this.pList.length; i++) {
      if (this.pList[i].text === this.control.value) {
        return true;
      }
    }

    return false;
  }

  public onIconClick($event: any) {
    const input = $event.target.parentNode.parentNode.querySelector('input');
    if (input) {
      input.focus();
    }
  }
}
